export const apiErrorToMessage = (error: string): string => {
  error = error.toLowerCase().replaceAll('_', ' ');
  error = error.charAt(0).toUpperCase() + error.slice(1);
  return error;
};
